<template>
  <div class="detailBox">
    <ul class="detailContent">
        <el-form
        :model="state.model"
        label-width="100px"
        style="width: 80%"
        :scroll-to-error="true"
        ref="domForm"
        :rules="rules"
      >
        <el-form-item label="是否启用">
          <el-switch v-model="state.model.IsQy" />
        </el-form-item>
        <el-form-item label="关联对象">
          <el-select
            v-model="state.model.GlLx"
            placeholder="请选择关联对象"
            clearable
            @change="onGlLxChange"
          >
            <el-option label="客户" value="kh"></el-option>
            <el-option label="游客" value="yk"></el-option>
            <el-option label="员工" value="yh"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="关联对象"
          v-if="state.model.GlLx"
        >
          <el-select
            v-if="state.model.GlLx === 'kh'"
            v-model="state.model.KhId"
            placeholder="请选择客户"
            clearable
            filterable
          >
            <el-option
              v-for="item in state.khList"
              :key="item.Id"
              :label="item.Mc"
              :value="item.Id"
            ></el-option>
          </el-select>
          <el-select
            v-else-if="state.model.GlLx === 'yk'"
            v-model="state.model.YkId"
            placeholder="请选择游客"
            clearable
            filterable
          >
            <el-option
              v-for="item in state.ykList"
              :key="item.Id"
              :label="`${item.Xm}(${item.Sjhm})`"
              :value="item.Id"
            ></el-option>
          </el-select>
          <el-select
            v-else-if="state.model.GlLx === 'yh'"
            v-model="state.model.YhId"
            placeholder="请选择员工"
            clearable
            filterable
          >
            <el-option
              v-for="item in state.yhList"
              :key="item.Id"
              :label="item.Xm"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="抬头类型"
          prop="Lx"
          :rules="[
            { required: true, message: '请选择抬头类型', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="state.model.Lx">
            <el-radio :label="1">个人</el-radio>
            <el-radio :label="2">企业</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="抬头名称"
          prop="Mc"
          :rules="[
            { required: true, message: '请输入抬头名称', trigger: 'blur' },
          ]"
        >
          <div style="display: flex; align-items: center; gap: 8px">
            <el-input
              v-model="state.model.Mc"
              :placeholder="state.model.Lx == 1 ? '请输入个人姓名' : '请输入企业名称'"
              maxlength="250"
              show-word-limit
              style="width: 350px"
              @blur="onMcBlur"
            ></el-input>
            <el-button
              v-if="state.model.Lx == 2"
              type="success"
              :loading="state.verifying"
              :disabled="!state.model.Mc || state.model.Mc.trim().length < 2"
              @click="onMcVerify"
            >
              {{ state.verifying ? '查询中...' : '工商验证' }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item
          v-if="state.model.Lx == 2"
          label="纳税人识别号"
          prop="Nsrsbh"
          :rules="[
            {
              required: state.model.Lx == 2,
              message: '企业抬头必须填写纳税人识别号',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="state.model.Nsrsbh"
            placeholder="请输入纳税人识别号（15位或18位）"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="state.model.Lx == 2"
          label="单位地址"
          prop="Dwdz"
        >
          <el-input
            v-model="state.model.Dwdz"
            placeholder="请输入单位地址"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="state.model.Lx == 2"
          label="单位电话"
          prop="Dwdh"
        >
          <el-input
            v-model="state.model.Dwdh"
            placeholder="请输入单位电话"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="state.model.Lx == 2"
          label="开户银行"
          prop="Khyh"
        >
          <el-input
            v-model="state.model.Khyh"
            placeholder="请输入开户银行"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="state.model.Lx == 2"
          label="银行账号"
          prop="Yhzh"
        >
          <el-input
            v-model="state.model.Yhzh"
            placeholder="请输入银行账号"
            maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否默认抬头">
          <el-switch v-model="state.model.IsMr" />
          <span style="margin-left: 10px; color: #999; font-size: 12px"
            >设置为默认后，开票时将自动选择此抬头</span
          >
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="state.model.Bz"
            type="textarea"
            :rows="3"
            placeholder="请输入备注信息（可选）"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <template v-if="props.id">
          <el-form-item label="创建人">
            <el-input v-model="state.model.CjrXm" disabled></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-input v-model="state.model.Cjsj" disabled></el-input>
          </el-form-item>
        </template>
      </el-form>
    </ul>
    <ul class="detailBtn">
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { fapiaotoutai_detail, fapiaotoutai_add, fapiaotoutai_edit, fapiaotoutai_company_verify } from "@/http/api";
import { kehu_select, youke_select, yonghu_select } from "@/http/api";
import { ElMessage } from "element-plus";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const domForm = ref(null);
    const state = reactive({
      model: {
        IsQy: true,
        Lx: 2,
        IsMr: false,
      },
      khList: [],
      ykList: [],
      yhList: [],
      verifying: false,
    });
    let originalMc = null;

    onMounted(() => {
      // 加载客户列表
      kehu_select().then((res) => {
        if (res.status == 200) {
          state.khList = res.data || [];
        }
      });

      // 加载游客列表
      youke_select().then((res) => {
        if (res.status == 200) {
          state.ykList = res.data || [];
        }
      });

      // 加载员工列表
      yonghu_select().then((res) => {
        if (res.status == 200) {
          state.yhList = res.data || [];
        }
      });

      if (props.id) {
        fapiaotoutai_detail(props.id).then((res) => {
          if (res.status == 200 && res.data?.model) {
            // 用 Object.assign 保留响应式引用，避免直接替换导致的渲染问题
            const cleanModel = { ...res.data.model };
            delete cleanModel.Kh;
            delete cleanModel.Yk;
            delete cleanModel.Yh;
            Object.assign(state.model, cleanModel);
            // 确定关联类型
            if (state.model.KhId) state.model.GlLx = 'kh';
            else if (state.model.YkId) state.model.GlLx = 'yk';
            else if (state.model.YhId) state.model.GlLx = 'yh';
            // 记录原始抬头名称，用于判断是否变化（避免失焦重复验证）
            originalMc = state.model.Mc || null;
          } else {
            ElMessage({ message: "获取发票抬头信息失败", type: "error", showClose: true });
          }
        }).catch((err) => {
          if (err?.status == 404) {
            ElMessage({ message: "发票抬头数据不存在或已被删除！", type: "error", showClose: true });
          } else {
            ElMessage({ message: "获取发票抬头信息失败，请重试", type: "error", showClose: true });
          }
          // 关闭弹窗
          setTimeout(() => emit("close"), 800);
        });
      }
    });

    const onGlLxChange = () => {
      // 清空之前的关联ID
      state.model.KhId = null;
      state.model.YkId = null;
      state.model.YhId = null;
    };

    // 实际提交保存
    const doSubmit = (submitData) => {
      if (props.id) {
        fapiaotoutai_edit(props.id, submitData).then((res) => {
          if (res.status == 200) {
            ElMessage({ message: "修改成功！", type: "success", showClose: true });
            setTimeout(() => emit("close", true), 500);
          } else {
            ElMessage({ message: res.data, type: "error", showClose: true, dangerouslyUseHTMLString: true });
          }
        });
      } else {
        fapiaotoutai_add(submitData).then((res) => {
          if (res.status == 200) {
            ElMessage({ message: "添加成功！", type: "success", showClose: true });
            setTimeout(() => emit("close", true), 500);
          } else {
            ElMessage({ message: res.data, type: "error", showClose: true, dangerouslyUseHTMLString: true });
          }
        });
      }
    };

    // 通过企业名称工商验证并自动填充
    const verifyAndFill = (mc, submitData) => {
      return fapiaotoutai_company_verify(mc).then((res) => {
        if (res.status == 200 && res.data) {
          const { creditCode, address, phone } = res.data;
          // 自动填充纳税人识别号（工商数据优先）
          if (creditCode) {
            submitData.Nsrsbh = creditCode;
            state.model.Nsrsbh = creditCode;
          }
          // 自动填充单位地址（工商数据优先）
          if (address) {
            submitData.Dwdz = address;
            state.model.Dwdz = address;
          }
          // 自动填充单位电话（工商数据优先）
          if (phone) {
            submitData.Dwdh = phone;
            state.model.Dwdh = phone;
          }
          ElMessage({ message: "工商验证通过", type: "success", showClose: true });
          return true;
        }
        return false;
      }).catch(() => {
        ElMessage({ message: "工商验证服务暂不可用", type: "warning", showClose: true });
        return false;
      });
    };

    // 点击工商验证按钮
    const onMcVerify = () => {
      const mc = state.model.Mc?.trim();
      if (!mc || mc.length < 2) {
        ElMessage({ message: "请输入完整的企业名称", type: "warning", showClose: true });
        return;
      }
      if (state.verifying) return;

      state.verifying = true;
      verifyAndFill(mc, state.model).finally(() => {
        state.verifying = false;
        originalMc = state.model.Mc; // 更新基准值
      });
    };

    // 抬头名称失焦时自动工商验证
    const onMcBlur = () => {
      const mc = state.model.Mc?.trim();
      // 个人类型不验证
      if (state.model.Lx != 2) return;
      // 名称太短不验证
      if (!mc || mc.length < 2) return;
      // 编辑模式且名称未修改，不重复验证
      if (props.id && mc === originalMc) return;
      // 正在验证中不重复触发
      if (state.verifying) return;

      state.verifying = true;
      verifyAndFill(mc, state.model).finally(() => {
        state.verifying = false;
        originalMc = state.model.Mc;
      });
    };

    const onSubmit = () => {
      domForm.value.validate((valid) => {
        if (!valid) return false;

        const submitData = { ...state.model };
        delete submitData.GlLx;

        // 企业类型且填写了抬头名称时，提交前做工商验证
        const mc = submitData.Mc?.trim();
        if (submitData.Lx == 2 && mc && mc.length >= 2) {
          state.verifying = true;
          verifyAndFill(mc, submitData).finally(() => {
            state.verifying = false;
            doSubmit(submitData);
          });
        } else {
          doSubmit(submitData);
        }
      });
    };

    return { state, onSubmit, props, domForm, onGlLxChange, onMcBlur, onMcVerify };
  },
};
</script>
<style scoped></style>